import { render, staticRenderFns } from "./MotionForm.vue?vue&type=template&id=68c981bd"
import script from "./MotionForm.vue?vue&type=script&lang=js"
export * from "./MotionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports